import format from 'date-fns/format';
import isBefore from 'date-fns/isBefore';
import { ptBR } from 'date-fns/locale';

export function ExpectedNormalizationDate({ date, dateOnly = false }) {
  if (!date) return <>-</>;

  const normalizedDate = new Date(date.replace(' ', 'T'));
  const now = new Date();
  const isPast = isBefore(normalizedDate, now);

  const formattedDate = format(
    normalizedDate,
    dateOnly ? 'dd/MM/yyyy' : 'dd/MM/yyyy HH:mm:ss',
    {
      locale: ptBR,
    },
  );

  return isPast ? (
    <strong style={{ color: '#ff0000' }}>{formattedDate}</strong>
  ) : (
    <span>{formattedDate}</span>
  );
}
